<script lang="ts" setup>
import { TripPlannerPage } from '../new-desktop/core/models/navigation';
import type { TripPlannerQueryParams } from '../new-desktop/core/models/navigation';
import { useQueryParamsStore } from '../new-desktop/core/stores/queryParamsStore';
import { useRouterStore } from '../new-desktop/core/stores/routerStore';
import { useRecipeStore } from '../new-desktop/core/stores/recipe/recipeStore';
import { usePaxStore } from '../new-desktop/core/stores';

import TripPlanner from './TripPlanner.vue';

const props = defineProps<TripPlannerQueryParams>();

const paxStore = usePaxStore();
const recipeStore = useRecipeStore();
const routerStore = useRouterStore();

const isCarTrip =
  routerStore.getCurrentTripPlannerView() === TripPlannerPage.CarTrip;

recipeStore.initializeProps({
  recipe: props.initialIngredients,
  preferredDay: props.initialSelectedDate,
  preferredMonth: props.initialSelectedMonth,
  itinerarySuggestionSortType: props.initialSuggestionSortType,
  returnTransport: props.returnTransport,
  metadata: props.metaData,
  searchForPackageRates: props.searchForPackageRates,
  isCarTrip,
});
paxStore.updatePax(props.initialPax);

const queryParamStore = useQueryParamsStore();
queryParamStore.setQueryParams(props);
routerStore.setLandingRoute();
</script>

<template>
  <TripPlanner v-bind="props" />
</template>
